// extracted by mini-css-extract-plugin
module.exports = {"container":"Voice_container__2UUin","title":"Voice_title__1d28U","sub-title":"Voice_sub-title__U5F8B","services":"Voice_services__2ujE5","details-item":"Voice_details-item__1knCG"};